export interface ErrorBoundaryState {
  error?: Error;
}

export interface ErrorBoundaryProps {
  component?: React.FC<ErrorBoundaryState>;
}

export interface ErrorBoundaryErrorInfo {
  componentStack: string;
}
